export const Users = [
    {
        id: 1,
        profilePicture: "posts/mypost.jpg",
        username: "Safak Kocaoglu",
    },
    {
        id: 2,
        profilePicture: "posts/hareesh.png",
        username: "Janell Shrum",
    },
    {
        id: 3,
        profilePicture: "posts/shukla.jpg",
        username: "Alex Durden",
    },
    
];

export const Posts = [
    {
        id: 1,
        desc: "Love For All, Hatred For None.",
        photo: "posts/mypost.jpg",
        date: "5 mins ago",
        userId: 1,
        like: 32,
        comment: 9,
    },
    {
        id: 2,
        photo: "person/kumar.jpg",
        date: "15 mins ago",
        userId: 2,
        like: 2,
        comment: 1,
    },
    
];